import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  format,
} from "date-fns";

export const getCalendarDays = (date: Date): Date[] => {
  const start = startOfWeek(startOfMonth(date), { weekStartsOn: 1 });
  const end = endOfWeek(endOfMonth(date), { weekStartsOn: 1 });

  return eachDayOfInterval({ start, end });
};

export const isSameMonth = (date: Date, currentMonth: Date) =>
  date.getMonth() === currentMonth.getMonth() &&
  date.getFullYear() === currentMonth.getFullYear();

//TimeDropdown.tsx

export const generateTimeOptions = (
  workingDays?: {
    [key: string]: { working: boolean; from: string; to: string };
  },
  currentDate?: Date,
  minHour = 0,
  maxHour = 23,
): string[] => {
  const times: string[] = [];

  // Georgian days of the week starting with Sunday

  let fromMinutes = minHour * 60;
  let toMinutes: number;

  if (workingDays && currentDate) {
    const currentDay = format(currentDate, "eeee").toLowerCase();

    const todayHours = workingDays[currentDay];

    if (todayHours?.working) {
      const [fromHour, fromMinute] = todayHours.from.split(":").map(Number);
      let [toHour, toMinute] = todayHours.to.split(":").map(Number);

      fromMinutes = fromHour * 60 + fromMinute;

      if (toHour === 0 && toMinute === 0) {
        // Closing at 00:00, treat as 24:00
        toMinutes = 24 * 60;
      } else {
        toMinutes = toHour * 60 + toMinute;
      }
    } else {
      // If the restaurant is not working today, return an empty array
      return times;
    }
  } else {
    // When workingDays or currentDate are not provided, use minHour and maxHour
    // To allow last reservation at maxHour:30, set toMinutes = (maxHour +1)*60
    toMinutes = (maxHour + 1) * 60;
  }

  // The last reservation should be 30 minutes before closing time
  const lastReservation = toMinutes - 30;

  for (let minutes = fromMinutes; minutes <= lastReservation; minutes += 30) {
    const hour = Math.floor(minutes / 60) % 24; // Ensure hour is within 0-23
    const minute = minutes % 60;
    const timeString = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
    times.push(timeString);
  }

  return times;
};

export const adjustToTimezone = (date: Date | string): Date => {
  const dateObj = new Date(date);
  const timezoneOffset = dateObj.getTimezoneOffset();
  return new Date(dateObj.getTime() + timezoneOffset * 60000);
};
